import {isAfter} from 'date-fns';
import {hasTimeLocking, hasTimeApproval} from '../../FeatureUtil';

interface CompanyLockedDateInput {
	companyLockYear: number | null;
	companyLockMonth: number | null;
	companyLockDay: number | null;
	personExcludedFromCompanyLock: boolean | null;
}

function getCompanyLockDate({
	companyLockYear,
	companyLockMonth,
	companyLockDay,
	personExcludedFromCompanyLock = false,
}: CompanyLockedDateInput): Date | null {
	if (hasTimeLocking() && !personExcludedFromCompanyLock && companyLockYear && companyLockMonth && companyLockDay) {
		return new Date(companyLockYear, companyLockMonth - 1, companyLockDay);
	}

	return null;
}

interface PersonLockedDateInput {
	personLockYear: number | null;
	personLockMonth: number | null;
	personLockDay: number | null;
}

function getPersonLockDate({personLockYear, personLockMonth, personLockDay}: PersonLockedDateInput): Date | undefined {
	if (personLockYear && personLockMonth && personLockDay) {
		return new Date(personLockYear, personLockMonth - 1, personLockDay);
	}
}

interface LockedDateInput extends CompanyLockedDateInput, PersonLockedDateInput {}

export function getLockDate({
	companyLockYear,
	companyLockMonth,
	companyLockDay,
	personLockYear,
	personLockMonth,
	personLockDay,
	personExcludedFromCompanyLock,
}: LockedDateInput): Date | null {
	if (hasTimeLocking()) {
		const companyLockDate = getCompanyLockDate({
			companyLockYear,
			companyLockMonth,
			companyLockDay,
			personExcludedFromCompanyLock,
		});
		if (hasTimeApproval()) {
			const personLockDate = getPersonLockDate({personLockYear, personLockMonth, personLockDay});
			if (!personLockDate && !companyLockDate) return null;
			if (!personLockDate || !companyLockDate) return personLockDate || companyLockDate;

			return isAfter(personLockDate, companyLockDate) ? personLockDate : companyLockDate;
		}

		return companyLockDate;
	}

	return null;
}
